var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from './svg-circle-icon';
export var ArrowsCrossingIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 56,
    glyphHeight: 57
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56 15.9416L44.9715 4.91309L41.4382 8.44637L46.4344 13.4426H39.4749C35.7094 13.4426 32.6006 15.0347 30.213 17.4223L30.1626 17.4728L13.676 35.9577C12.096 37.5141 9.98676 38.4267 7.99492 38.4267H0V43.4236H7.99492C11.4796 43.4236 14.8444 41.8563 17.2568 39.4439L17.3072 39.3934L33.7943 20.9079C35.3937 19.3279 37.2663 18.4394 39.4749 18.4394H46.4356L41.4382 23.4368L44.9715 26.9701L56 15.9416ZM7.99492 18.4394H0V13.4426H7.99492C11.4795 13.4426 14.8444 15.0099 17.2568 17.4223L17.3246 17.4902L18.8861 19.3119L15.0923 22.5638L13.6595 20.8923C12.0814 19.3458 9.97984 18.4394 7.99492 18.4394ZM28.5837 37.5561L32.3775 34.3042L33.811 35.9765C35.4067 37.5463 37.274 38.4286 39.4749 38.4286H46.4362L41.4382 33.4306L44.9715 29.8973L56 40.9258L44.9715 51.9543L41.4382 48.4211L46.4339 43.4254H39.4749C35.7094 43.4254 32.6006 41.8333 30.213 39.4457L30.1452 39.3778L28.5837 37.5561Z"
  }));
};
export var ArrowsCrossingIconGlyph = function (props) {
  return React.createElement(ArrowsCrossingIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};